export default {
      id: "oc-proxmox-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "sprite.svg#oc-proxmox",
      toString: function () {
        return this.url;
      }
    }